import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Announcement02 } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_news")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("news", context.tenant.modules);

    return {
      title: () => context.t("Organization news", { ns: "news.shared" }),
      crumb: [
        {
          Icon: Announcement02,
        },
        {
          label: context.t("Organization news", { ns: "news.shared" }),
          link: { to: "/admin/news" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
